import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from '../public/locales/en/translation.json';
import itTranslation from '../public/locales/it/translation.json';
import frTranslation from '../public/locales/fr/translation.json';
import esTranslation from '../public/locales/es/translation.json';
import deTranslation from '../public/locales/de/translation.json';
import { DEFAULT_LANGUAGE, getBrowserLanguage, LANGUAGE_STORAGE_KEY, normalizeLanguage, SUPPORTED_LANGUAGES } from './i18n/languages';

const storedLanguage = typeof localStorage !== 'undefined'
  ? localStorage.getItem(LANGUAGE_STORAGE_KEY)
  : null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      it: { translation: itTranslation },
      fr: { translation: frTranslation },
      es: { translation: esTranslation },
      de: { translation: deTranslation }
    },
    lng: normalizeLanguage(storedLanguage || getBrowserLanguage() || DEFAULT_LANGUAGE),
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    cleanCode: true,
    interpolation: { escapeValue: false }
  });

export default i18n;
